export default {
  chosenCategoryObj(store) {
    const res = (store.subcategories.find((el) => el.id === store.subcategory_id));
    if (res) return res;

    return store.subcategories[0];
  },
};
